import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shareCard" }
const _hoisted_2 = { class: "menuLinkWrapper" }
const _hoisted_3 = { class: "menueLinkBtTxt" }
const _hoisted_4 = {
  style: {"display":"flex"},
  class: "mediaListMain"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"color":"#b4e6ec","font-size":"9px"} }

import { getActivityInformations } from '@/api/common'
import { InfoConfig, MEDIA_LIST } from '@/view/bauDoTesouro/supportScript'
import { Share } from '@capacitor/share';
import { onMounted, ref } from 'vue'
import InputField from '../../bauDoTesouro/components/inputField.vue';
import { copyID } from '@/view/profile/supportScript';
import StatusPopup from '@/components/common/statusPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'shareCard',
  setup(__props) {

const mediaList = ref(MEDIA_LIST)
const activityConfig = ref<InfoConfig>({
    equipment_limit: '',
    ip_limit: '',
    recharge_require: '',
    turnover_require: '',
    turnover_require_times: '',
    valid_user_count: 0,
    link: '',
    reward_conf: []
})
const statusRef = ref()
const onCopyID = (id: any) => copyID(statusRef, id)
const getActivityInfo = () => {
    let data = {
        activityId: "user_referral_reward"
    }

    getActivityInformations(data).then(res => {

        const resData = res.data
        // bannerIcon.value = resData?.floatIcon
        // descriptionHtml.value = JSON.parse(resData.activityIntro)
        activityConfig.value = resData.config
        // activityStore.setActivityData(resData.config.recharge_require, resData.config.turnover_require, resData.config.ip_limit)
    }).catch(err => {
        console.error('Error fetching activity info:', err)
    })
}
const goToShare = async () => {
    let shareLink = activityConfig.value?.link
    try {
        if (!shareLink) { return }
    await Share.share({
        text: shareLink,
    });
    } catch (error) {
       console.warn('Not supporting') 
    }
    
}
onMounted(() => {
    getActivityInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.quickShare')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, { class: "shareField" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "6",
            class: "text1"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("ink de Indicação:")
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "14",
            class: "text2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(activityConfig.value?.link), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "4",
            class: "text3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onCopyID(activityConfig.value?.link)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.copy')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('common.quickShare')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mediaList",
            onClick: goToShare,
            style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","padding":"8px"}
          }, [
            _createElementVNode("img", {
              src: item.icon,
              style: {"height":"24.75px","width":"24.75px"},
              class: "",
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(item.name)), 1)
          ]))
        }), 128))
      ]),
      _createVNode(StatusPopup, {
        ref_key: "statusRef",
        ref: statusRef,
        content: _ctx.$t('common.copied'),
        isShowSuccess: true
      }, null, 8, ["content"])
    ])
  ]))
}
}

})